"use client";

import { clsx } from "clsx";
import { useEffect, useRef, useState, useSyncExternalStore } from "react";
import * as m from "motion/react-m";
import type { ReactNode } from "react";

const LG_MQ = "(max-width: 1023px)";

function subscribeLg(cb: () => void) {
  const mq = window.matchMedia(LG_MQ);
  mq.addEventListener("change", cb);
  return () => mq.removeEventListener("change", cb);
}

function snapshotLg() {
  return window.matchMedia(LG_MQ).matches;
}

export function CompactFormCard({ children }: { children: ReactNode }) {
  const isBelowLg = useSyncExternalStore(subscribeLg, snapshotLg, () => false);
  const contentRef = useRef<HTMLDivElement>(null);
  const [height, setHeight] = useState<number | "auto">("auto");

  useEffect(() => {
    if (!isBelowLg) {
      setHeight("auto");
      return;
    }

    const el = contentRef.current;
    if (!el) return;

    const observer = new ResizeObserver(() => {
      if (el) {
        setHeight(el.offsetHeight);
      }
    });

    observer.observe(el);
    return () => observer.disconnect();
  }, [isBelowLg]);

  return (
    <m.div
      animate={{ height }}
      className={clsx(
        "tw-mx-auto lg:tw-max-w-xl",
        "max-lg:tw-overflow-hidden max-lg:tw-rounded-2xl max-lg:tw-bg-white max-lg:tw-text-black",
      )}
      transition={{ height: { duration: 0.3, ease: "easeInOut" } }}
    >
      <div ref={contentRef} className='max-lg:tw-p-6 sm:max-lg:tw-p-8'>
        {children}
      </div>
    </m.div>
  );
}
